import { render, staticRenderFns } from "./TablesView.vue?vue&type=template&id=ba9aceaa&scoped=true"
import script from "./TablesView.vue?vue&type=script&lang=js"
export * from "./TablesView.vue?vue&type=script&lang=js"
import style0 from "./TablesView.vue?vue&type=style&index=0&id=ba9aceaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9aceaa",
  null
  
)

export default component.exports